import { useMutation } from "@tanstack/react-query";

import getTbiApi from "@/api/api-v1";
import { useInvalidateUserQueries } from "@/queries/query-users";
import { useOnError } from "@/utils/on-error";

export function useDeleteUser() {
  const invalidateUserQueries = useInvalidateUserQueries();
  const onError = useOnError("Gebruiker verwijderen mislukt.");
  return useMutation({
    mutationFn: async (id: number) => {
      await getTbiApi().UsersApi.usersDestroy({
        id: id.toString(),
      });
      invalidateUserQueries(id);
    },
    onError,
  });
}
